import { useMutation } from '@tanstack/react-query'
import { uploadCredential } from '../../api/user'

export function useUploadCredentialMutation(
  userId: string,
  options?: {
    onSuccess?: () => void
    onError?: (error: Error) => void
  }
) {
  return useMutation({
    mutationFn: ({
      file,
      credentialType,
      workerRequirementId,
      expiresAt,
    }: {
      file: File
      credentialType: string
      workerRequirementId?: string
      expiresAt?: string
    }) =>
      uploadCredential(
        userId,
        file,
        credentialType,
        workerRequirementId,
        expiresAt
      ),
    ...options,
  })
}
